import Error from './index'

export default [{
  path: '*',
  name: 'Error404',
  component: Error,
  meta: {auth: true, bodyClass: 'blank', code: 404}
}, {
  path: '*',
  name: 'Error403',
  component: Error,
  meta: {auth: true, bodyClass: 'blank', code: 403}
}]



// WEBPACK FOOTER //
// ./src/pages/error/router.js